import { render, staticRenderFns } from "./SmartKitchenCounters.vue?vue&type=template&id=b290fbb6&scoped=true&"
import script from "./SmartKitchenCounters.vue?vue&type=script&lang=js&"
export * from "./SmartKitchenCounters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b290fbb6",
  null
  
)

export default component.exports